import { PartialTenantCustomizations } from "src/tenantCustomizations/TenantCustomizations";
import { OmegakeittiotPurchaseRequestDataGridActionBarComponents } from "./OmegakeittiotPurchaseRequestDataGridActionBarComponents";
import { OmegakeittiotShopOrderBatchContextMenuComponents } from "src/tenantCustomizations/tenants/omegakeittiot/OmegakeittiotShopOrderBatchContextMenuComponents.tsx";
import {
	getInventoryLevelEventQuantitySpcSamplingMethod,
	getInventoryLevelEventTotalWeightSpcSamplingMethod,
} from "src/components/views/erp/spcSamplingMethods/inventoryLevelEventSpcSamplingMethods.tsx";
import { getOmegakeittiotShopOrderBatchDataGridCustomColumns } from "src/tenantCustomizations/tenants/omegakeittiot/omegakeittiotShopOrderBatchDataGridCustomColumns.tsx";
import { defaultSpcSamplingMethods } from "src/tenantCustomizations/defaultTenantCustomizations";

export const omegakeittiotCustomizations: PartialTenantCustomizations = {
	tenantConfig: {
		erp: {
			enabled: true,
			configuratorEnabled: true,
		},
		tasks: {
			enabled: false,
		},
		documentsEnabled: false,
	},
	purchaseRequestsDataGridActionBarComponents: OmegakeittiotPurchaseRequestDataGridActionBarComponents,
	spcSamplingMethods: () => [
		...defaultSpcSamplingMethods,
		getInventoryLevelEventQuantitySpcSamplingMethod(),
		getInventoryLevelEventTotalWeightSpcSamplingMethod(),
	],
	erp: {
		production: {
			shopOrderBatchContextMenuComponents: OmegakeittiotShopOrderBatchContextMenuComponents,
			shopOrderBatchDataGridCustomColumns: getOmegakeittiotShopOrderBatchDataGridCustomColumns,
			addShopOrdersToBatchView: {
				configuratorFilterComponents: [{ componentUuid: "c376b1bb-04d6-441e-af99-241eb52169cb" }],
			},
		},
	},
} as const;
